/** Copy helpers for empty list / search / filter states. */

export function searchEmpty(entityName: string): string {
  return `No ${entityName} found. Try adjusting your search criteria.`;
}

export function zeroData(entityName: string): string {
  return `No ${entityName} found.`;
}

export function filteredEmpty(entityName: string): string {
  return `No ${entityName} match the selected filters.`;
}
